import React from 'react';
import { faq, italistLegit, ordersAndShipping, returnsPolicy } from '../../helpers/routes';
import { mailTo, customerCareEmail } from '../../helpers/emailAddresses';

const CustomerSupportText: React.FC<{ buildUrlWithCountry: (url: string) => string }> = ({ buildUrlWithCountry }) => (
  <>
    Questions, concerns, issues?
    <br /> Visit our{' '}
    <a href={buildUrlWithCountry(faq)} style={{ fontSize: '15px', textDecoration: 'underline' }}>
      FAQ
    </a>{' '}
    or contact us:{' '}
    <a href={mailTo(customerCareEmail)} style={{ fontSize: '15px', textDecoration: 'underline' }}>
      customercare@italist.com
    </a>
    .<br /> We’re always here for you &#10084;
  </>
);

const AuthenticText: React.FC<{ buildUrlWithCountry: (url: string) => string }> = ({ buildUrlWithCountry }) => (
  <>
    We partner with Italy’s best luxury retailers and work together with them to provide you{' '}
    <a href={buildUrlWithCountry(italistLegit)} style={{ fontSize: '15px', textDecoration: 'underline' }}>
      100% authentic pieces
    </a>
    , certified twice — by both them and us.
  </>
);

const ShippingText: React.FC<{ buildUrlWithCountry: (url: string) => string }> = ({ buildUrlWithCountry }) => (
  <>
    We offer free express international shipping on every order to ensure your pieces arrive quickly and safely. Learn
    more about our{' '}
    <a href={buildUrlWithCountry(ordersAndShipping)} style={{ fontSize: '15px', textDecoration: 'underline' }}>
      shipping process
    </a>{' '}
    and{' '}
    <a href={buildUrlWithCountry(returnsPolicy)} style={{ fontSize: '15px', textDecoration: 'underline' }}>
      returns policy
    </a>
    .
  </>
);

export const infoBoxCopy = (buildUrlWithCountry: (url: string) => string, s3BasePath: string) => [
  {
    text: <CustomerSupportText buildUrlWithCountry={buildUrlWithCountry} />,
    title: '24/7 CUSTOMER SUPPORT',
  },
  {
    text: <AuthenticText buildUrlWithCountry={buildUrlWithCountry} />,
    title: '100% AUTHENTIC',
  },
  {
    text: <ShippingText buildUrlWithCountry={buildUrlWithCountry} />,
    title: 'FREE EXPRESS SHIPPING',
  },
  {
    icons: [
      { src: `${s3BasePath}mkt/icon/Visa-logo.jpg`, style: { height: '25px', width: '35px' } },
      { src: `${s3BasePath}mkt/icon/visa_electron.jpg`, style: { height: '20px', width: '35px' } },
      { src: `${s3BasePath}mkt/icon/jcb.png`, style: { height: '25px', width: '40px' } },
      {
        src: `${s3BasePath}mkt/icon/Mastercard-PNG-Clipart.png`,
        style: { height: '25px', width: '40px' },
      },
      { src: `${s3BasePath}mkt/icon/Logo+DHL_Express.png`, style: { height: '40px', width: '75px' } },
    ],
    text: (
      <>
        Your purchases are protected by encrypted security systems that keep your personal data and payment information
        safe and secure.
      </>
    ),
    title: 'SECURE SHOPPING',
  },
];
